module.exports = __webpack_public_path__ + "static/media/ImagineInternet_PP_2019.d74572da.pdf";